module.exports = __webpack_public_path__ + "img/card-event-02-button-sm.42004fd4.svg";